import React from 'react';

import {Box, Skeleton, Stack, Paper, Typography, Button} from 'views/components';
import {Add as AddIcon, DescriptionOutlined as DescriptionOutlinedIcon} from 'views/icons';
import {Translate} from 'views/module';

const NotesTileSkeleton = () => {
  return (
    <Paper sx={{p: 2, mb: 2, borderRadius: 4, height: 118.5}}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <DescriptionOutlinedIcon sx={{width: 24, height: 24, color: '#b0b0b0'}} />
          <Typography variant="h6">
            <Translate expression='schedule.eventDetail.NotesSection.Title' />
          </Typography>
        </Stack>
        <Button
          size="small"
          startIcon={<AddIcon />}
          onClick={() => setEditing(true)}
          sx={{
            'color': 'black',
            'backgroundColor': '#ffffff',
            'border': '1px solid #e0e0e0',
            'borderRadius': 2,
            'textTransform': 'none',
            'fontSize': '14px',
            'fontWeight': 'normal',
            '& .MuiButton-startIcon': {
              marginRight: '3px',
            },
            '&:hover': {
              backgroundColor: '#f8f9fa',
              borderColor: '#d0d0d0',
            },
          }}
        >
          <Translate expression='schedule.eventDetail.NotesSection.AddNoteButton' />
        </Button>
      </Stack>
      <Box sx={{background: '#f7f7f7', p: 1.5, borderRadius: 1, position: 'relative'}}>
        <Skeleton variant="text" width="100%" height={16} />
      </Box>
    </Paper>
  );
};

export default NotesTileSkeleton;
